import { format, parseISO } from "date-fns";

const EXIF_STYLE_DATE_PREFIX = /^(\d{4}):(\d{2}):(\d{2})/;
const EMPTY_EXIF_DATE_RE =
  /^(0000:00:00|0000-00-00)(?:[ T]00:00:00(?:\.\d+)?)?$/;

function toIsoLikeDateString(value) {
  return value.replace(EXIF_STYLE_DATE_PREFIX, "$1-$2-$3").replace(" ", "T");
}

export function normalizeDateTaken(value) {
  if (value === null || value === undefined) return null;

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return format(value, "yyyy-MM-dd'T'HH:mm:ss");
  }

  if (typeof value !== "string") return null;

  const trimmed = value.trim();
  if (!trimmed) return null;
  if (EMPTY_EXIF_DATE_RE.test(trimmed)) return null;

  const isoLike = toIsoLikeDateString(trimmed);
  const parsed = parseISO(isoLike);
  if (Number.isNaN(parsed.getTime())) return null;

  // Keep dateTaken in one local-time format in app state.
  return format(parsed, "yyyy-MM-dd'T'HH:mm:ss");
}

export function areDateTakenEqual(left, right) {
  return normalizeDateTaken(left) === normalizeDateTaken(right);
}
